import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import { useZoomSettings } from "../hooks/useZoomSettings";
import "./FAQModal.css";

const FAQModal = ({ isOpen, onClose }) => {
  const { settings } = useZoomSettings();
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [expandedQuestions, setExpandedQuestions] = useState({});

  // topic_list와 questions 가져오기
  const topicList = settings?.topic_list || [];
  const questions = settings?.questions || [];

  // 모달이 열릴 때 "전체" 선택
  useEffect(() => {
    if (isOpen && !selectedTopic) {
      setSelectedTopic("전체");
    }
  }, [isOpen, selectedTopic]);

  // 선택된 토픽에 해당하는 질문 필터링 (show: true인 것만)
  const filteredQuestions = questions.filter((q) => {
    if (q.show !== true) return false;
    if (selectedTopic === "전체") return true;
    return q.type === selectedTopic;
  });

  // 질문 토글 핸들러
  const handleQuestionToggle = (index) => {
    setExpandedQuestions((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // 모달 닫을 때 상태 초기화
  const handleClose = () => {
    setExpandedQuestions({});
    setSelectedTopic(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="faq-modal-overlay" onClick={handleClose}>
      <div className="faq-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* 헤더 */}
        <div className="faq-modal-header">
          <h2 className="faq-modal-title">자주 묻는 질문</h2>
          <button className="faq-modal-close-btn" onClick={handleClose}>
            <MdClose size={24} />
          </button>
        </div>

        {/* 토픽 탭 */}
        <div className="faq-topic-tabs">
          {/* 전체 탭 */}
          <button
            className={`faq-topic-tab ${
              selectedTopic === "전체" ? "active" : ""
            }`}
            onClick={() => {
              setSelectedTopic("전체");
              setExpandedQuestions({}); // 토픽 변경 시 아코디언 닫기
            }}
          >
            전체
          </button>
          {/* 기타 토픽 탭 */}
          {topicList.map((topic) => (
            <button
              key={topic}
              className={`faq-topic-tab ${
                selectedTopic === topic ? "active" : ""
              }`}
              onClick={() => {
                setSelectedTopic(topic);
                setExpandedQuestions({}); // 토픽 변경 시 아코디언 닫기
              }}
            >
              {topic}
            </button>
          ))}
        </div>

        {/* 질문 목록 */}
        <div className="faq-questions-container">
          {filteredQuestions.length > 0 ? (
            filteredQuestions.map((question, index) => (
              <div key={index} className="faq-question-item">
                <button
                  className="faq-question-header"
                  onClick={() => handleQuestionToggle(index)}
                >
                  <span className="faq-question-title">{question.title}</span>
                  <span
                    className={`faq-question-icon ${
                      expandedQuestions[index] ? "expanded" : ""
                    }`}
                  >
                    ▼
                  </span>
                </button>
                {expandedQuestions[index] && (
                  <div className="faq-question-body">
                    <div className="faq-question-content">{question.body}</div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="faq-empty-state">
              {selectedTopic
                ? "해당 카테고리에 등록된 질문이 없습니다."
                : "등록된 질문이 없습니다."}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQModal;
